import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import { FaTimes } from "react-icons/fa";

const DeleteDialog = ({ open, closeDialog, deleteRecord, deleteId, msg }) => {
  return (
    <div>
      <Dialog id="dialogBox" open={open} onClose={closeDialog}>
        <DialogTitle>
          <div className="row">
            <div className="col-1 text-right ml-auto">
              <FaTimes
                onClick={() => {
                  closeDialog();
                }}
                className="crossview cp"
              />
            </div>
          </div>
        </DialogTitle>
        <DialogContent>
          <div className="clear10"></div>
          <div className="row">
            <div className="col-12 text-center">
              <p className="fs-20 semi-bold text-center mb-4">{msg}</p>
            </div>
            <div className="d-flex align-items-center justify-content-center gap-10 w-100">
              <button
                type="button"
                class="cancelbtn"
                onClick={() => {
                  closeDialog();
                }}
              >
                No
              </button>
              <button
                type="button"
                class="yes-btn"
                onClick={() => {
                  deleteRecord(deleteId);
                }}
              >
                Yes, Delete
              </button>
            </div>
          </div>
          <div className="clear10"></div>
          <div className="clear10"></div>
        </DialogContent>
      </Dialog>
    </div>
  );
};

export default DeleteDialog;
